import React from "react";
import { Row, Col, Card, Typography, Button } from "antd";
import { useNavigate } from "react-router-dom";

import g1 from "../../assets/g1.jpg";
import g2 from "../../assets/g2.jpg";
import g3 from "../../assets/g3.jpg";
import g4 from "../../assets/g4.jpg";
import g5 from "../../assets/g5.jpg";
import g6 from "../../assets/g6.jpg";

const { Title, Text } = Typography;

const galleryData = [
  {
    images: [g1, g2, g3],
    title: "Nellab 1",
  },
  {
    images: [g4, g5, g6],
    title: "Nellab 2",
  },
  {
    images: [g1, g2, g3],
    title: "Nellab 3",
  },
];

const GallerySection = () => {
  const navigate = useNavigate();

  return (
    <Row gutter={[16, 16]}>
      {galleryData.map((item, idx) => (
        <Col xs={24} sm={12} md={8} key={idx}>
          <Card
            hoverable
            style={{ borderRadius: 0, overflow: "hidden", minHeight: 350 }}
            bodyStyle={{ padding: 0 }}
          >
            {/* ✅ Responsive layout */}
            <div
              style={{
                display: "flex",
                gap: 4,
                flexDirection: window.innerWidth < 600 ? "column" : "row",
              }}
            >
              <img
                src={item.images[0]}
                alt="big-img"
                style={{
                  width: window.innerWidth < 600 ? "100%" : "65%",
                  height: 340,
                  objectFit: "cover",
                }}
              />
              <div
                style={{
                  width: window.innerWidth < 600 ? "100%" : "35%",
                  display: "flex",
                  flexDirection: window.innerWidth < 600 ? "row" : "column",
                  gap: 4,
                }}
              >
                <img
                  src={item.images[1]}
                  alt="small-top"
                  style={{ height: 168, width: "100%", objectFit: "cover" }}
                />
                <img
                  src={item.images[2]}
                  alt="small-bottom"
                  style={{ height: 168, width: "100%", objectFit: "cover" }}
                />
              </div>
            </div>

            <div style={{ padding: 12 }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
                <Text style={{ fontSize: 12, color: "#444" }}>{item.date}</Text>
              </div>

              <Title level={5} style={{ margin: "6px 0" }}>
                {item.title}
              </Title>

              <Button
                type="link"
                style={{ padding: 0, fontWeight: 600, fontSize: 13, color: "#000" }}
                onClick={() => navigate("/view-gallery")}
              >
                VIEW NOW —
              </Button>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

const Gallery = () => (
  <div style={{ padding: "50px 20px", background: "#f9f9f9" }}>
    <Title level={2} style={{ marginBottom: 25, textAlign: "left" }}>
      Gallery
    </Title>

    {/* ✅ Section 1 */}
    <GallerySection />

    <div style={{ margin: "50px 0" }}></div>

  </div>
);

export default Gallery;
